<article class="panel-container" [ngClass]="panelSize">
  <ng-content select="nav"></ng-content>
  <ng-content select="header"></ng-content>
  <ng-content select="section"></ng-content>
  <ng-content select="footer"></ng-content>
</article>
